<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="$root.navbar.collapsed" :label="$lang.collapsed"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="$root.navbar.floating" :label="$lang.floating"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="$root.navbar.temporary" :label="$lang.temporary"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="$root.navbar.right" :label="$lang.right"  :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
    </flex>
  </container>
</template>
<script>
export default {
  name: 'PageNavbar'
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/navbar.vue